module.exports = __webpack_public_path__ + "static/scale-model-of-buckroe-beach-and-park-in-hampton-virginia-9034c1973de894f5f1289ac84eed515d.png";